/** @format */

import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// import parse from "html-react-parser"
// import {format} from "@flasd/whatsapp-formatting"
import BootstrapDialogTitle from "./BootstrapDialogTitle";
import WAPreviewBody from "./WAPreviewBody";
import React from "react";

WAPreviewBody.propTypes = {
  content: PropTypes.string,
  footer: PropTypes.string,
  headerFormat: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

// const classes = {
//   message: {
//     color: "#000",
//     clear: "both",
//     lineHeight: "18px",
//     fontSize: "15px",
//     padding: "8px",
//     position: "relative",
//     margin: "8px 0",
//     maxWidth: "85%",
//     wordWrap: "break-word",
//     background: "#fff",
//     borderRadius: "0px 7px 7px 7px",
//     float: "left",
//     display: "flex",
//     flexDirection: "column",
//   },
//   afterMessage: {
//     position: "absolute",
//     width: 0,
//     height: 0,
//     borderStyle: "solid",
//     borderWidth: "0px 10px 10px 0",
//     borderColor: "transparent #fff transparent transparent",
//     top: 0,
//     left: "-10px",
//   },
//   metadata: {
//     display: "inline-block",
//     float: "right",
//     alignSelf: "flex-end",
//     padding: "0 0 0 16px",
//     position: "relative",
//     bottom: "-4px",
//     color: "rgba(0, 0, 0, .45)",
//     fontSize: "11px",
//   },
//   footer: {
//     color: "rgba(0, 0, 0, .45)",
//   },
//   header: {
//     fontWeight: "bold",
//   },
//   videoMeta: {
//     position: "absolute",
//     bottom: 0,
//     color: "white",
//     zIndex: 10,
//     fontSize: "10px",
//     marginLeft: "5px",
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//   },
//   button: {
//     color: "#48a5ee",
//     clear: "both",
//     lineHeight: "18px",
//     fontSize: "15px",
//     padding: "8px",
//     position: "relative",
//     margin: "8px 0",
//     marginTop: "-4px",
//     maxWidth: "85%",
//     wordWrap: "break-word",
//     background: "#fff",
//     borderRadius: "0px 7px 7px 7px",
//     float: "left",
//     textAlign: "center",
//   },
//   urlButton: {
//     color: "#48a5ee",
//     clear: "both",
//     lineHeight: "18px",
//     fontSize: "15px",
//     padding: "8px",
//     position: "relative",
//     wordWrap: "break-word",
//     background: "#fff",
//     float: "left",
//     textAlign: "center",
//   },
//   urlButtonLine: {
//     lineHeight: "18px",
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     width: "100%",
//   },
// };

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    width: 400,
    minHeight: 300,
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function WAPreviewModal({
  content,
  open,
  setOpen,
  footer,
  header,
  headerFormat,
  buttonType,
  buttonQuickReply,
  buttonPhoneNumberURL,
  isPreview,
}) {
  return (
    <BootstrapDialog open={open} onClose={() => setOpen(false)}>
      <BootstrapDialogTitle onClose={() => setOpen(false)}>
        Preview
      </BootstrapDialogTitle>

      <Box display="flex">
        <Box p="10px" display={isPreview ? "none" : "block"}>
          <Typography>
            To help WhatsApp understand what kind of message you want to send,
            please provide specific content examples for your template. You can
            add a sample file for one or all languages you are submitting.
          </Typography>
        </Box>
        <DialogContent
          sx={{
            px: 3,
            background: "url(/static/wabg.jpg) repeat",
          }}
        >
          <div
            style={{
              width: "85%",
            }}
          >
            <WAPreviewBody
              content={content}
              open={open}
              footer={footer}
              header={header}
              headerFormat={headerFormat}
              buttonType={buttonType}
              buttonQuickReply={buttonQuickReply}
              buttonPhoneNumberURL={buttonPhoneNumberURL}
            />
          </div>
        </DialogContent>
      </Box>

      <DialogActions>
        <Button autoFocus onClick={() => setOpen((prev) => !prev)}>
          Close
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
